import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  searchIsOpen: false,
  searchValue: '',
  searchBoxValue: '',
  data: [],
  resultsLimited: false,
  importCount: 0,
  propertyCount: 0,
  auctionCount: 0,
  loading: false,
  isSearchingLastPriced: false
}

// create slice will call createAction and createReducer for us internally
const slice = createSlice({
  name: 'searchSlice',
  initialState,
  reducers: {
    setSearchState: (state, action) => { // Triggers searchResultFetchSaga
      return {
        ...state,
        ...action.payload
      };
    },
    fetchSearchLastPricedByMe: (state, action) => { 
      return {
        ...state,
        ...action.payload
      }
    },

    // Redux saga actions, no reducers
    fetchSearch: () => { } // Triggers searchResultFetchSaga
  }
});

export default slice.reducer;

export const searchActions = slice.actions;

// Memoized selectors

